import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  RowCustomAction
} from '@globaleris/ui.library'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TaskActionModel } from '../../../../api/Argentia/endpoints/tasks/model/tasks'
import { getCustomerDomain } from '../../../../redux'
import { PlayCircleFilled } from '@material-ui/icons'

interface TaskActionsTableProps {
  data: TaskActionModel[],
  onSelectActionModel: (selectedRow: TaskActionModel) => void
}

export const TaskActionsTable: React.FC<TaskActionsTableProps> = ({
  data,
  onSelectActionModel
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])

  const getRowCustomActions = () => {
    const actions: RowCustomAction[] = [
      {
        icon: <PlayCircleFilled fontSize="small" />,
        tooltip: t('tasks:components.taskActionTable.tooltips.rowExecuteAction'),
        onClick: onSelectActionModel 
      }
    ]

    return actions
  }

  // const getSelectToolbarCustomActions = () => {
  //   const selecToolbarActions: CustomAction[] = [
  //     {
  //       icon: <PlayCircleFilled fontSize="small" />,
  //       tooltip: t('tasks:components.taskActionTable.tooltips.toolbarExecuteAction'),
  //       onClick: (selectedRows: TaskActionModel[]) => {
  //         onTableExecuteActionClick(selectedRows)
  //       }
  //     }
  //   ]

  //   return selecToolbarActions
  // }

  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'code',
      label: t('tasks:components.taskActionTable.columns.code'),
      type: DataType.TEXT
    },
    {
      name: 'description',
      label: t('tasks:components.taskActionTable.columns.description'),
      type: DataType.TEXT
    }
  ]

  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    filterType: FilterType.ADVANCED,
    elevation: 0,
    download: false,
    canEdit: false,
    canDelete: false,
    canInsert: false,
    customInsertEditModal: false,
    pagination: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('tasks:components.taskActionTable.analytics')
    },
    rowCustomActions: getRowCustomActions(),
    // selectToolbarCustomActions: getSelectToolbarCustomActions()
  }

  return (
    <DataTable
      data={data}
      columns={columns}
      options={options}
    />
  )
}
